import { dashboardTheme as sharedDashboardTheme, themeTokens } from "src/components/DashboardTheme";
import type { ThemeMode } from "../types";

export { themeTokens };

export const dashboardTheme = ({ themeMode }: { themeMode?: ThemeMode }) => sharedDashboardTheme({ themeMode });

export const MONTH_ROW_MIN_HEIGHT = 148;
export const MONTH_SPAN_TOP_OFFSET = 34;
export const MONTH_SPAN_ITEM_HEIGHT = 22;
export const MONTH_SPAN_ROW_GAP = 6;
export const MONTH_DAY_ITEM_HEIGHT = 22;
export const MONTH_DAY_ITEM_GAP = 4;
export const MONTH_DAY_FOOTER_SPACE = 28;
export const MONTH_DAY_EXTRA_BOTTOM_SPACE = 10;
